import OrderService from '../../services/OrderService'
import router from '@/router'

const state = () => ({
    loadingOrder: false,
    order: null,
    orders: [],
    total: 0,
    pages: 0,
    page: 1,
    totalOrdersPendentes: null,
    show_modal_new_order: false,
    new_order: {
        payment_method_id: "",
        amount: null,
        installments: 1,
        description: "",
        UserId: null,
        SubscriptionId: null,
        PlanId: null,
        CuponId: null,
        DiscountId: null,
        transaction_id: null,
        external_reference: null,
        customer_id: null,
        identificationNumber: null,
        cardholderEmail: null,
        status: "approved",
        orderStatus: "entregue"
    },
})
  
const mutations = {
    SET_ORDER: (state, payload) => {
        state.order =  payload
    },
    SET_ORDERS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.orders = payload.orders
        }else{
            state.orders = [...state.orders, ...payload.orders]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total
    },
    SET_LOADING_ORDER: (state, payload) => {
        state.loadingOrder = payload
    },
    SET_TOTAL_ORDERS_PENDENTES: (state, payload) => {
        state.totalOrdersPendentes = payload.pendingLogsCount
    },
    SET_SHOW_MODAL_NEW_ORDER: (state, payload) => {
        state.show_modal_new_order = payload
    },
}

const actions = {
    async fetchOrders({commit}, { keyword = '', pageNumber = 1, sortBy = 'mais recentes' }){
        try{
            commit('SET_LOADING_ORDER', true)
            const response = await OrderService.get(keyword, pageNumber, sortBy);
            commit('SET_ORDERS', response.data)
            commit('SET_LOADING_ORDER', false)
        } catch (error) {
            commit('SET_LOADING_ORDER', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchOrder({commit}, id){
        // try{
            commit('SET_LOADING_ORDER', true)
            const response = await OrderService.getOne(id);
            response.data.deliveryAddress = JSON.parse(response.data.deliveryAddress);
            response.data.shippingMethod = JSON.parse(response.data.shippingMethod);
            commit('SET_ORDER', response.data)
            if(response.data.OrderShippings && response.data.OrderShippings.length) {
                commit('SET_SHIPPING', response.data.OrderShippings[0])
            }
            commit('SET_LOADING_ORDER', false)
        // } catch (error) {
        //     commit('SET_LOADING_ORDER', false);
        //     // commit('LOG_USER_OUT');
        //     commit('SET_ALERT', {
        //         heading: 'error',
        //         message: error.response.data.message
        //     });
        // }
    },
    async fetchTotalPendentesPendentes({commit}){
        try{
            commit('SET_LOADING_ORDER', true)
            const response = await OrderService.getTotalPendentes();
            commit('SET_TOTAL_ORDERS_PENDENTES', response.data)
            commit('SET_LOADING_ORDER', false)
        } catch (error) {
            commit('SET_LOADING_ORDER', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createOrderWithPayment({commit, state, rootState}, data){
        try{
            commit('SET_LOADING_ORDER', true)
            data.CartItens = rootState.product.cart
            const response = await OrderService.createWithPayment(data);
            commit('SET_ALERT', { heading: 'success', message: response.data.message });
            commit('SET_SHOW_MODAL_NEW_ORDER', false)
            state.new_order = {   payment_method_id: "", amount: null, installments: 1, description: "", UserId: null, SubscriptionId: null, PlanId: null, CuponId: null, DiscountId: null, transaction_id: null, external_reference: null, customer_id: null, identificationNumber: null, cardholderEmail: null, status: "approved", orderStatus: "entregue" };
            commit('CLEAR_CART')
            router.push({path: `/form_order/${response.data.order.id}`});
            commit('SET_LOADING_ORDER', false)
        } catch (error) {
            commit('SET_LOADING_ORDER', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeOrder({commit}, data){
        try{
            commit('SET_LOADING_ORDER', true)
            const objOrder = Object.assign({}, data); 
            objOrder.deliveryAddress = JSON.stringify(objOrder.deliveryAddress); 
            objOrder.shippingMethod = JSON.stringify(objOrder.shippingMethod); 
            const response = await OrderService.update(objOrder);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_ORDER', false)
        } catch (error) {
            commit('SET_LOADING_ORDER', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getOrder: state => state.order,
    getNewOrder: state => state.new_order,
    getOrders: state => state.orders,
    getLoadingOrder: state => state.loadingOrder,
    getTotalOrdersPendentes: state => state.totalOrdersPendentes,
    getShowModalNewOrder: state => state.show_modal_new_order,
}

export default {
    state,
    getters,
    mutations,
    actions
};